import { useEffect } from 'react'
interface RedirectProps {
  to: string
}
function Redirect({ to }: RedirectProps) {
  useEffect(() => {
    if (window) {
      window.location.href = to
    }
  }, [to])

  return null
}

export default Redirect
